/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as l from "react";
import { GridContext as r } from "../../GridClientWrapper.mjs";
import { TableSelection as n } from "@progress/kendo-react-data-tools";
const m = (e) => {
  const t = l.useContext(r);
  return /* @__PURE__ */ l.createElement(
    n,
    {
      selectable: e.selectable,
      onRelease: t.selectionRelease,
      childRef: (a) => {
        t.tableElementRef.current = a;
      }
    },
    /* @__PURE__ */ l.createElement(
      "table",
      {
        className: e.tableClassName,
        role: "presentation",
        style: e.tableStyle,
        ref: t.tableElementRef
      },
      e.children
    )
  );
};
export {
  m as GridTableScrollable
};
